
(function () {
  const SELECTOR = '[data-cart-rewards]';
  const root = window.Shopify?.routes?.root || '/';

  let lastSignature = null;
  let requestVersion = 0;
  let refreshTimer = null;
  let checking = false;

  function getSignature(cart) {
    return JSON.stringify({
      items: cart.items.map(item => ({
        key: item.key,
        quantity: item.quantity
      })),
      total: cart.total_price
    });
  }

  async function getCart() {
    const response = await fetch(`${root}cart.js`, {
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Cart request failed');
    }

    return response.json();
  }

  function findRewards(container) {
    // Normal DOM
    const direct = container.querySelector(SELECTOR);

    if (direct) return direct;

    // Palo Alto stores drawer markup inside a template
    const templates = container.querySelectorAll('template');

    for (const template of templates) {
      const rewards = template.content.querySelector(SELECTOR);

      if (rewards) return rewards;
    }

    return null;
  }

  async function refreshRewards() {
    const version = ++requestVersion;

    try {
      const response = await fetch(
        `${root}?sections=header`,
        {
          credentials: 'same-origin',
          cache: 'no-store'
        }
      );

      if (!response.ok) {
        throw new Error('Header section request failed');
      }

      const sections = await response.json();
      const html = sections.header;

      if (!html) {
        throw new Error('Header section HTML missing');
      }

      const doc = new DOMParser().parseFromString(
        html,
        'text/html'
      );

      const updatedSubtotal = doc.querySelector(
  'template[data-cart-drawer-template]'
)?.content.querySelector('[data-cart-summary-total]');

const currentSubtotal = document.querySelector(
  '[data-cart-summary-total]'
);

if (updatedSubtotal && currentSubtotal) {
  currentSubtotal.innerHTML = updatedSubtotal.innerHTML;
}

      const updated = findRewards(doc);

      if (!updated) {
        throw new Error('Rewards tracker not found in header');
      }

      if (version !== requestVersion) return;

      // Update visible tracker and any template copies
      const current = document.querySelector(SELECTOR);

      if (current) {
        current.replaceWith(updated.cloneNode(true));
      }

      document
        .querySelectorAll('template[data-cart-drawer-template]')
        .forEach(template => {
          const tracker = template.content.querySelector(SELECTOR);

          if (tracker) {
            tracker.replaceWith(updated.cloneNode(true));
          }
        });

      console.log(
        'Cart rewards updated:',
        updated.dataset.eligibleQuantity
      );

    } catch (error) {
      console.warn('Cart rewards update failed:', error);
    }
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);

    refreshTimer = setTimeout(refreshRewards, 150);
  }

  async function checkCart() {
    if (checking) return;

    checking = true;

    try {
      const cart = await getCart();
      const signature = getSignature(cart);

      if (lastSignature === null) {
        lastSignature = signature;
        return;
      }

      if (signature !== lastSignature) {
        lastSignature = signature;
        scheduleRefresh();
      }

    } catch (error) {
      console.warn('Cart rewards check failed:', error);
    } finally {
      checking = false;
    }
  }

  function init() {
    // Initial cart state
    checkCart();

    // Detect completed AJAX cart changes
    setInterval(checkCart, 800);

    // Update when returning to the tab
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) checkCart();
    });

    // Update after Shopify theme sections reload
    document.addEventListener('shopify:section:load', () => {
      scheduleRefresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
